/**
 * @generated SignedSource<<02d9b8b68b66f5f5bf32275f81a0a49d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_rankField$data = {
  readonly rankField?: {
    readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider527BadPattern">;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_ListView_rankField";
};
export type main_issueNavigator_ListView_rankField$key = {
  readonly " $data"?: main_issueNavigator_ListView_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_rankField",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraJqlFieldWithAliases",
          "kind": "LinkedField",
          "name": "rankField",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "NativeIssueTableWithSelectedIssuesProvider527BadPattern"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "312d4259d594db85bc82a09d5984064b";

export default node;
